const getLowestEndpointPrice = (endpoints) => {
    const pricesArray = endpoints ? endpoints.filter(e => {
        if (!e.labels) return true;
        return !(e.labels.isFriendly || e.labels.isFree || e.labels.isPromo || e.labels.isStem || e.labels.isReserved);
    }).map(e => e.price).sort((a, b) => a - b) : [];
    if (pricesArray.length) {
        return pricesArray[0];
    } else {
        return null;
    }
};

export default getLowestEndpointPrice;